<mat-toolbar class="header">
  <mat-divider style="background-color: beige"></mat-divider>
  <img src="../../../../../assets/img/logo-fundos.svg" class="logo" />
  2022 Ticketernal</mat-toolbar
>
